import { getMembers, memberIsNotEmpty } from '../../NestedTable/utils';
import { isLegacyType } from '../../typeParser';
import { getTypeSuffix } from '../../../../../utils/typeUtils';
import { getCallbackIfNeeded } from '../../NestedTable/NestedTableTypeDisplay/utils';

const isLastItem = (arr, i) => arr.length - 1 === i;
export const rpcRequestTypeDisplay = (item, store) => {
  return `${item.params.reduce((accm, param, i) => {
    const paramMember = getMembers(store)(param.type);
    if (!memberIsNotEmpty(paramMember)) {
      return `${accm}{}`;
    }
    if (param.optional) {
      return `${accm}[${param.name}]${isLastItem(item.params, i) ? '' : ', '}`;
    } else {
      return `${accm}${param.name}${isLastItem(item.params, i) ? '' : ', '}`;
    }
  }, '(')})`;
};

export const getResponseDisplayName = (responseMember) => {
  return !memberIsNotEmpty(responseMember) ? '{}' : responseMember.displayName;
};

export const getResponseSyntaxDisplay = (ret, store) => {
  const responseMember = getMembers(store)(ret.type);
  return `(${getResponseDisplayName(responseMember)})`;
};

export const renderJSFunctionDisplay = (func, store) => {
  const callbacks = (func.params || [])
    .map((param) => {
      const callback = getCallbackIfNeeded(param.type, param.metaData, store);
      return callback
        ? {
            ...callback,
            paramInFunction: param.name,
          }
        : null;
    })
    .filter((callbackOrNull) => !!callbackOrNull);

  return (
    `function ${func.name && func.name.replace(/\s+/, '')}${getParamText(
      func,
    )}: ${getRetText(func)}` +
    callbacks.map(
      (callback) =>
        `\n${callback.paramInFunction}: function ${callback.name}${getParamText(
          callback,
        )}: ${getRetText(callback)}`,
    )
  );
};

export const getRetText = (item) => {
  const ret = item.ret || { type: [{ nativeType: 'void' }] };
  return getTypeText(ret.displayName || ret.type);
};

const getParamText = (item) => {
  let paramText = '';
  if (item.params && item.params.length && item.params.length > 0) {
    paramText = `(`;
    item.params.forEach((param) => {
      if (param.optional) {
        paramText += `[${param.name}: ${param.spread ? '...' : ''}${getTypeText(
          param.type,
        )}], `;
      } else {
        paramText += `${param.name}: ${param.spread ? '...' : ''}${getTypeText(
          param.type,
        )}, `;
      }
    });
    paramText = paramText.substring(0, paramText.length - 2);
    paramText += `)`;
  } else if (item.params) {
    // || item.get) {
    paramText = '()';
  }
  return paramText;
};

export const withSeparator = (separator) => (r, a, idx, src) =>
  idx < src.length - 1 ? r.concat(a, separator) : r.concat(a);

export const getTypeText = (type) => {
  const getSubTypeText = (innerType) => getTypeText(innerType);

  const getSimpleType = (simpleType: string) => {
    const lastDotIndex = Math.max(simpleType.lastIndexOf('.') + 1, 0);
    return simpleType.substr(lastDotIndex);
  };

  if (isLegacyType(type)) {
    if (typeof type === 'string') {
      return getSimpleType(type);
    } else if (Array.isArray(type)) {
      return type.map(getSubTypeText).reduce(withSeparator(' | '), []).join('');
    } else if (typeof type === 'object') {
      if (type.name && type.typeParams) {
        return [
          `${type.name}<`,
          ...type.typeParams
            .map(getSubTypeText)
            .reduce(withSeparator(', '), []),
          `>`,
        ].join('');
      }
      return '';
    }
    return `Object`;
  } else {
    if (Array.isArray(type)) {
      return type.map(getSubTypeText).reduce(withSeparator(' | '), []).join('');
    } else {
      if (type.nativeType) {
        return type.nativeType;
      } else if (type.referenceType) {
        return type.displayName || getSimpleType(type.referenceType);
      } else if (type.complexType) {
        const prefix =
          type.complexType.nativeType ||
          type.complexType.displayName ||
          getTypeSuffix(type.complexType.referenceType);
        return [
          `${prefix}<`,
          ...type.complexType.typeParams
            .map(getSubTypeText)
            .reduce(withSeparator(', '), []),
          `>`,
        ].join('');
      }
    }
  }
};
